// Paramètres que Keycloak ajoute à l'URL de retour, à retirer une fois la connexion traitée.
// Ceux d'une erreur (connexion annulée…) comptent aussi : restés dans le `redirect_uri`, ils
// reviendraient avec le `code` de la tentative suivante, qu'oidc-client-ts traiterait en erreur.
const OIDC_PARAMS = [
  "state",
  "session_state",
  "iss",
  "code",
  "id_token",
  "access_token",
  "token_type",
  "scope",
  "error",
  "error_description",
  "error_uri",
  "kc_action",
  "kc_action_status",
];

/**
 * Chemin, requête et ancre de l'URL de retour de Keycloak, débarrassés des paramètres OIDC :
 * ceux de la page demandée avant la connexion (lien profond) sont conservés.
 */
export const pathWithoutOidcParams = (href: string): string => {
  const url = new URL(href);
  OIDC_PARAMS.forEach((param) => url.searchParams.delete(param));
  return url.pathname + url.search + url.hash;
};
